import React, { memo, useCallback, useMemo } from 'react';
import Traductor from '../../Traductor';

const ManagementFiltersTags = ({ filters, onDeleteTag }) => {
    const t = useMemo(() => new Traductor(), []);
    const renderTags = useCallback(() => {
        const tags = [['name', filters.name]].concat(
            Object.entries(filters.status)
        );

        return tags.reduce((acc, [key, value], i) => {
            if (value) {
                return [
                    ...acc,
                    <li key={`${key}${i}`} className="u-m-none u-mr u-mv@s">
                        <span className="c-tag  positive">
                            <span className="c-tag__label">
                                {typeof value === 'string'
                                    ? value
                                    : t.getTraduction(
                                          `ManagementFiltersStatus`
                                      )[key]}
                            </span>
                            <button
                                className="c-tag__close"
                                title="Close"
                                type="button"
                                aria-label={`Remove ${key} tag`}
                                onClick={() =>
                                    typeof value === 'string'
                                        ? onDeleteTag({
                                              ...filters,
                                              [key]: '',
                                          })
                                        : onDeleteTag({
                                              ...filters,
                                              status: {
                                                  ...filters.status,
                                                  [key]: false,
                                              },
                                          })
                                }
                            />
                        </span>
                    </li>,
                ];
            }
            return acc;
        }, []);
    }, [filters, onDeleteTag, t]);

    return <ul className="c-tag-list u-m-none">{renderTags()}</ul>;
};

export default memo(ManagementFiltersTags);
